export default __webpack_public_path__ + "static/media/helmet.9fe1f154.svg";